/* Ott-common */
import { OrbisResourceType, BlimResourceType } from '@dtvgo/constants';

/**
 * @enum {string}
 * @readonly
 */
export const EntityName = {
  PAGE: 'pages',
  SECTION: 'sections',
  ASSET: 'assets',
  BANNER: 'banners',
  STATION: 'stations',
  STATION_CATEGORY: 'stationCategories',
  SHOW: 'shows',
  SEASON: 'seasons',
  VOD_CONTENT: 'vodContents',
  LIVE_CONTENT: 'liveContents',
  BLIM_STATION: 'blimStations',
};

/**
 * @enum {string}
 * @readonly
 */
export const PROVIDER = {
  ORBIS: 'Orbis',
  BLIM: 'Blim',
  THINK_ANALYTICS: 'ThinkAnalytics',
};

export const SectionId = {
  CONTINUE_WATCHING: 'SIGUEVIENDO',
  CONTINUE_WATCHING_TA: 'UCTAContinueWatching',
  MOST_WATCHED: 'MOST_WATCHED',
  FEATURED: 'Featured',
  FEATURED_CONTENT: 'FeaturedContent',
};

/**
 * @enum {string}
 * @readonly
 */
export const BLIM_PICTURES_TYPE = {
  BACKGROUND: 'BACKGROUND',
  COVER_VERTICAL: 'COVER_VERTICAL',
};

/**
 * @enum {number}
 * @readonly
 */
export const Source = {
  Orbis: 1,
  Blim: 2,
};

/**
 * @enum {number}
 * @readonly
 */
export const ContentSourceType = {
  OrbisLive: 1,
  OrbisVod: 2,
  BlimLive: 101,
  BlimVod: 102,
};

export const OrbisResourceTypeByBlimResourceType = {
  [BlimResourceType.MOVIE]: OrbisResourceType.VOD_MOVIE,
  [BlimResourceType.EPISODE]: OrbisResourceType.VOD_EPISODE,
  [BlimResourceType.SERIE]: OrbisResourceType.SHOW,
  [OrbisResourceType.SHOW]: OrbisResourceType.SHOW,
  default: OrbisResourceType.VOD_EVENT,
};

export const OrbisLiveResourceTypeByBlimResourceType = {
  [BlimResourceType.MOVIE]: OrbisResourceType.LIVE_MOVIE,
  [BlimResourceType.EPISODE]: OrbisResourceType.LIVE_EPISODE,
  default: OrbisResourceType.LIVE_EVENT,
};
